import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { RestApiService } from './rest-api.service';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as XLSX from 'xlsx';

@Injectable({
    providedIn: 'root'
})
export class MessageService implements OnInit {

    private subject = new Subject<any>();
    private gridSubject = new Subject<any>();
    private colDefSubject = new Subject<any>();
    private cellChangeSubject = new Subject<any>();
    private selectedSubject = new Subject<any>();
    private rowSubject = new Subject<any>();
    private userAuthSubject = new Subject<any>();
    private afterDeleteSubject = new Subject<any>();
    private totalDataSubject = new Subject<any>();
    urlPathSubject = new Subject<any>();
    private clientUserAuth = new Subject<any>();
    private modalSubject = new Subject<any>();
    private moduleSubject = new Subject<any>();
    public createTicketSubject = new Subject<any>();
    private respObject: any;
    masterCloseModalSubject = new Subject<any>();
    tokenSubject = new Subject<any>();
    closeModalSubject = new Subject<any>();
    SECRET_TOKEN = 'secret%stupa@auth.token#@';

    // UPLOAD_PATH = 'https://ifix-uat-2.s3.amazonaws.com/';

    UPLOAD_MESSAGE = 'Your request to upload submitted successfully.Change status will be reflected after few minutes';
    REPORT_SUCCESS = 'Dear User,We have received your request for the report. The report generation is in progress and would require some time.' +
        '\n Please refresh the page using the Refresh button. When the report is ready, it will appear under the Report File Name section.'
        + '\nThank You.';
    EDIT_SUCCESS = 'Updated Successfully';
    FILTER_ERROR = 'No filter is mapped for this account.Please go to dashboard and set filter';
    BLANK_ERROR_MESSAGE = 'All the fields are mandatory';
    SERVER_ERROR = 'Something went wrong..Please try again later';
    CATEGORY_ERROR = 'All Category values are mandatory. Please select Function, Module and Sub Module values properly.';
    INCIDENT_ERROR = 'Please select atlest one incident type ticket';
    BLANK_COMMENT = 'Please provide some comments';
    BLANK_SOLUTION = 'Please provide some solutions';
    BLANK_TYPE = 'Please select a ticket type.';
    BLANK_USER = 'Please assign a user before forwarding';
    BLANK_USER_SOLUTION = 'Please assign a user before providing solution';
    BLANK_TICKETID = 'Please enter a valid TICKET ID';
    BLANK_ACTION = 'Please provide atleast one permission';
    URL_TOKEN_ERROR1 = 'Your session has been expired(1).Please try again later.You\'ll be redirected to login page';
    URL_TOKEN_ERROR = 'Your session has been expired.Please try again later.You\'ll be redirected to login page';
    // TOKEN_TIMEOUT_ERROR = 'Currently we are facing internal network issue due to high load.Please try again later';
    TOKEN_TIMEOUT_ERROR = 'It seems your INTERNET connection is too slow! please contact your local IT for support or try again later.';
    CATEGORY1_ERROR = 'Category 1 is missing.You\'ll be redirected to login page';
    CATEGORY2_ERROR = 'Category 2 is missing.You\'ll be redirected to login page';
    CATEGORY3_ERROR = 'Category 2 is missing.You\'ll be redirected to login page';
    SRCTYPE_ERROR = 'Source type is missing.You\'ll be redirected to login page';
    BLANK_STATUS = 'Please select a Status before update it';
    USER_NOT_FOUND = 'User Details With PSNO. Is Not Found In Employee Portal. Please Contact L&T Employee Portal Admin';
    USER_NOT_FOUND_NETWORK = 'PS No details are not available currently. System is too busy.' +
        '\n Click on "Generate Requester Info" button to try again later';
    USER_NOT_FOUND_SYSTEM = 'This PS NO has not been activated in iFIX. Please contact Administrator / SPOC.';
    CHANGE_STATUS = 'Please change the ticket status before forwarding.';
    SELF_ASSIGN = 'Please assign to yourself before forwarding.';
    NO_CATEGORY_FOUND = 'No category found for ticket creation.You are going to be logged out';
    NO_SOLUTION = 'No Solution Provided Yet';
    NO_TICKET_TYPE = 'Please provide a ticket type before login';
    BLANK_FIELD = 'Fill all mandatory field';
    SEQUENCE_ERROR = 'Enter a valid sequence number';
    RESOLUTION_TIME_ERROR = 'Resolution time must be greater than response time';
    ADDITIONAL_FIELD_ERROR = 'Please input all the additional fields';
    CSAT_RATING = 'Please provide a rating';
    CHILD_PARENT_TICKET_SAME = 'Parent ticket can\'t be a child ticket of it\'s own';
    RATING_ERROR_MSG = 'Rating must be integer only';
    SCHEDULE_TICKET_TIME_ERROR = 'Schedule ticket time must be greater than current time';
    BLANK_ASSET = 'Select any asset and then click add asset button';
    BLANK_ATTACHMENT = 'You need to attach a file before upload';
    CANCEL_SUCCESS = 'Ticket cancel successfully';
    REVIEW_SUCCESS = 'Ticket Review successfully';
    CLOSE_SUCCESS = 'Ticket Closed Successfully';
    ACTUAL_ACTIVITY_CHECK = 'Actual activity end date must be greater than Actual activity start date';
    FORWARD_WORKFLOW_END = 'Please select the correct support group/Assignee before forwarding the ticket';
    SUB_CLIENT_ERROR = 'Sorry, you can not insert data';
    WORKING_TIME_ERROR = 'End time should be greater than the Start time';
    BLANK_ASSIGNE_USER = 'Please select Assignee before forwarding the ticket';
    UPLOAD_ALERT_BEFORE_UPDATE = 'Please upload the file by clicking upload button before clicking the update ticket button';
    REPORT_TIME = 'Report should be generated between 31 Days';
    MANDATE_UPLOAD = 'Please upload the master data before initiating process.';
    BLANK_RESULT = 'No data found';

    view = false;
    add = false;
    edit = false;
    del = false;
    clientId: number;
    baseFlag: boolean;

    // DOCU_TYPE = 10;
    // adminNavbar = [];
    // adminNavbarModules = [];
    // pageSelected = 1;
    // pagination = [{ 'id': 1, 'value': 200 }, { 'id': 2, 'value': 500 }, { 'id': 3, 'value': 1000 }];
    // pageSize = this.pagination[0].value;
    // searchPagination = [{ 'id': 1, 'value': 50 }, { 'id': 2, 'value': 100 }];
    // searchPageSelected = 2;
    // searchPageSize = this.searchPagination[1].value;
   
   
    DOCU_TYPE = 10;
    adminNavbar = [];
    adminNavbarModules = [];
    pageSelected = 1;
    pagination = [{ 'id': 1, 'value': 50 }, { 'id': 2, 'value': 100 }, { 'id': 3, 'value': 1000 }];
    pageSize = this.pagination[0].value;
    searchPagination = [{ 'id': 1, 'value': 50 }, { 'id': 2, 'value': 100 }];
    searchPageSelected = 4;
    searchPageSize = this.pagination[0].value;
    searchPaginationBulk = [{'id': 1, 'value': 10 },{ 'id': 2, 'value': 15 },{'id': 3, 'value': 25},{'id': 4, 'value': 50},{'id': 4, 'value': 100}];
    searchPageSizeBulk = this.pagination[0].value;
    // searchPageSizeBulk = this.searchPaginationBulk[1].value;
   
    client: string;
    roleId: number;
    roleName: string;
    groupId = [];
    mobile: string;
    email: string;
    name: string;
    loginName: string;
    logOutUrl: string;
    dashboardUrl: string;
    searchUrl: string;
    groupMapUrl: string;
    scheduleTicketUrl: string;
    faqUrl: string;
    bulkAssigmentUrl :string;
    reassigmentUrl :string;
    createUrl: string;
    viewUrl: string;
    UPLOAD_PATH: string;
    TICKET_ID: any;
    wfcresultId: any;
    statusSeq: any;
    statusSelected: any;
    ASSET_REPORT_PATH: string;
    FAQ_PATH: string;
    currentGroup: string;
    upload_path: string;
    TCS_FAQ_PATH: string;
    isAttachChildSTaskTicket: boolean;
    clientCode: string;
    constructor(private route: Router, private _rest: RestApiService, private config: ConfigService) {
        this.getClientUserAuth().subscribe(auth => {
            this.view = auth[0].viewFlag;
            this.add = auth[0].addFlag;
            this.edit = auth[0].editFlag;
            this.del = auth[0].deleteFlag;
            this.clientId = auth[0].clientId;
            this.baseFlag = auth[0].baseFlag;
            this.client = auth[0].client;
            this.roleId = auth[0].roleId;
            this.roleName = auth[0].roleName;
            this.groupId = auth[0].groupId;
            this.mobile = auth[0].mobile;
            this.email = auth[0].email;
            this.name = auth[0].name;
            this.loginName = auth[0].login_name;
            this.upload_path = auth[0].upload_path;
            this.UPLOAD_PATH = this.config.UPLOAD_PATH_BASE + auth[0].upload_path + '/ticket/';
            this.ASSET_REPORT_PATH = this.config.UPLOAD_PATH_BASE + auth[0].upload_path + '/asset/';
            this.FAQ_PATH = this.config.UPLOAD_PATH_BASE + auth[0].upload_path + '/faqDocs/';
            this.TCS_FAQ_PATH = this.config.UPLOAD_PATH_BASE + 'ifix-uat/lnt_chr/faqDocs/';
        });
    }


    API_ROOT = this.config.API_ROOT;
    API_URL = this.API_ROOT + '/#';
    LNT_SSC_PATH = 'lnt_ssc';
    LNT_IMS_PATH = 'lnt_cit_ims';
    LNT_CHR_PATH = 'lnt_chr';
    LNT_APPS_PATH = 'lnt_cit_apps';
    REPORT_PATH = this.config.UPLOAD_PATH_BASE;

    ngOnInit(): void {

    }


    setTicketData() {
        this.createTicketSubject.next();
    }

    getTicketData() {
        this.createTicketSubject = new Subject<any>();
        return this.createTicketSubject.asObservable();
    }

    setTotalData(data: number) {
        this.totalDataSubject.next(data);
    }

    getModuleData(): Observable<any> {
        this.moduleSubject = new Subject<any>();
        return this.moduleSubject.asObservable();
    }

    getUrlPath(): Observable<any> {
        this.urlPathSubject = new Subject<any>();
        return this.urlPathSubject.asObservable();
    }

    getTotalData(): Observable<any> {
        this.totalDataSubject = new Subject<any>();
        return this.totalDataSubject.asObservable();
    }

    sendAfterDelete(id: any) {
        this.afterDeleteSubject.next(id);
    }

    getAfterDelete(): Observable<any> {
        this.afterDeleteSubject = new Subject<any>();
        return this.afterDeleteSubject.asObservable();
    }

    setClientUserAuth(id: any) {
        this.clientUserAuth.next(id);
    }

    getClientUserAuth(): Observable<any> {
        // this.clientUserAuth = new Subject<any>();
        return this.clientUserAuth.asObservable();
    }

    setUserAuth(data: any) {
        this.userAuthSubject.next(data);
    }

    getUserAuth(): Observable<any> {
        // this.userAuthSubject = new Subject<any>();
        return this.userAuthSubject.asObservable();
    }

    setGridWidth(width: number) {
        this.subject.next(width);
    }

    getGridWidth(): Observable<any> {
        this.subject = new Subject<any>();
        return this.subject.asObservable();
    }

    setColumnDefinitions(data: any) {
        this.colDefSubject.next(data);
    }

    setGridData(data: any) {
        this.gridSubject.next(data);
    }

    getColumnDefinitions(): Observable<any> {
        this.colDefSubject = new Subject<any>();
        return this.colDefSubject.asObservable();
    }

    getGridData(): Observable<any> {
        this.gridSubject = new Subject<any>();
        return this.gridSubject.asObservable();
    }

    setCellChangeData(data: any) {
        this.cellChangeSubject.next(data);
    }

    setSelectedItemData(data: any) {
        this.selectedSubject.next(data);
    }

    getCellChangeData(): Observable<any> {
        this.cellChangeSubject = new Subject<any>();
        return this.cellChangeSubject.asObservable();
    }

    getSelectedItemData(): Observable<any> {
        this.selectedSubject = new Subject<any>();
        return this.selectedSubject.asObservable();
    }

    setRow(row: any) {
        this.rowSubject.next(row);
    }

    getRow(): Observable<any> {
        this.rowSubject = new Subject<any>();
        return this.rowSubject.asObservable();
    }

    xorEncode(str, key) {
        let output = '';

        for (let i = 0; i < str.length;) {
            for (let j = 0; (j < key.length && i < str.length); j++, i++) {
                output += String.fromCharCode(str[i].charCodeAt(0) ^ key[j].charCodeAt(0));
            }
        }

        return output;
    }

    copyArray(aObject) {
        if (!aObject) {
            return aObject;
        }

        let v;
        const bObject = Array.isArray(aObject) ? [] : {};
        for (const k in aObject) {
            v = aObject[k];
            bObject[k] = (typeof v === 'object') ? this.copyArray(v) : v;
        }

        return bObject;
    }

    changeRouting(path: string) {
        // console.log(path);
        const originalPath = path;
        if (path !== undefined) {
            if (path.indexOf('https://') > -1) {
                path = path.substring('https://'.length, path.length);
            }
            const pos = path.indexOf('/#/');
            const url = path.substring(0, pos);
            const subpath = path.substring(pos + 3, path.length);
            // console.log('urlllllllllllllllllll' + url, subpath, location.host);
            // if (path.indexOf('http://') > -1) {
            //   path = path.substring('http://'.length, path.length);
            // }
            // const pos = path.indexOf('/');
            // const url = path.substring(0, pos);
            // let subpath = path.substring(pos + 1, path.length);
            // const routePos = subpath.indexOf('/');
            // subpath = subpath.substring(routePos + 1, subpath.length);
            if (url === location.host) {
                this.route.navigate([subpath]);
            } else {
                console.log('outside:' + originalPath);
                window.location.href = originalPath;
            }
        }
    }

    getUrl(path: string) {
        if (this.adminNavbar.length > 0) {
            const index = this.adminNavbar.map(function (d) {
                return d['path'];
            }).indexOf(path);
            let prevPath, nextPath;
            if (index === 0) {
                nextPath = this.adminNavbar[index + 1].path;
            } else if (index === this.adminNavbar.length - 1) {
                prevPath = this.adminNavbar[index - 1].path;
            } else if (index === -1) {
                nextPath = undefined;
                prevPath = undefined;
            } else {
                nextPath = this.adminNavbar[index + 1].path;
                prevPath = this.adminNavbar[index - 1].path;
            }
            this.urlPathSubject.next({ prevPath: prevPath, nextPath: nextPath });
        } else {
            this._rest.getAdminModule().subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    for (let i = 0; i < this.respObject.details[0].admin.length; i++) {
                        this.respObject.details[0].admin[i].path = this.API_URL + this.respObject.details[0].admin[i].path;
                        this.adminNavbar.push(this.respObject.details[0].admin[i]);
                    }
                    for (let i = 0; i < this.respObject.details[0].client.length; i++) {
                        this.respObject.details[0].client[i].path = this.API_URL + this.respObject.details[0].client[i].path;
                        this.adminNavbar.push(this.respObject.details[0].client[i]);
                    }
                    const index = this.adminNavbar.map(function (d) {
                        return d['path'];
                    }).indexOf(path);
                    let prevPath, nextPath;
                    if (index === 0) {
                        nextPath = this.adminNavbar[index + 1].path;
                    } else if (index === this.adminNavbar.length - 1) {
                        prevPath = this.adminNavbar[index - 1].path;
                    } else if (index === -1) {
                        nextPath = undefined;
                        prevPath = undefined;
                    } else {
                        nextPath = this.adminNavbar[index + 1].path;
                        prevPath = this.adminNavbar[index - 1].path;
                    }
                    this.urlPathSubject.next({ prevPath: prevPath, nextPath: nextPath });
                } else {
                }
            }, (err) => {

            });
        }
    }

    getUserId() {
        return sessionStorage.getItem('id');
    }

    setUserRole(UserRole) {
        sessionStorage.setItem('UserRole', UserRole);
    }

    getUserRole() {
        return sessionStorage.getItem('UserRole');
    }

    setUserRoleid(UserRoleid) {
        sessionStorage.setItem('UserRoleid', UserRoleid);
    }

    getUserRoleid() {
        return sessionStorage.getItem('UserRoleid');
    }

    getToken() {
        return sessionStorage.getItem('data');
    } 
   
    setClientCode(ClientCode) {
        sessionStorage.setItem('clientCode', ClientCode);
    }

    getclientCode() {
        return sessionStorage.getItem('clientCode');
    }

    clearClientData() {
        sessionStorage.removeItem('clientCode');
        sessionStorage.removeItem('clientId');
    }


    getModules() {
        if (this.adminNavbarModules.length > 0) {

            this.moduleSubject.next(this.adminNavbarModules);

        } else {
            this._rest.getAdminModule().subscribe((res) => {
                this.respObject = res;
                this.adminNavbarModules = [];
                if (this.respObject.success) {
                    for (let i = 0; i < this.respObject.details[0].admin.length; i++) {
                        this.respObject.details[0].admin[i].path = this.API_URL + this.respObject.details[0].admin[i].path;
                        this.adminNavbarModules.push(this.respObject.details[0].admin[i]);
                    }
                    for (let i = 0; i < this.respObject.details[0].client.length; i++) {
                        this.respObject.details[0].client[i].path = this.API_URL + this.respObject.details[0].client[i].path;
                        this.adminNavbarModules.push(this.respObject.details[0].client[i]);
                    }

                    this.moduleSubject.next(this.adminNavbarModules);
                } else {
                }
            }, (err) => {

            });
        }
    }


    isBlankField(data) {
        let isBlank = false;
        const keys = Object.keys(data);
        // console.log(JSON.stringify(keys));
        for (let i = 0; i < keys.length; i++) {
            let stringVal, numberVal;
            if (typeof data[keys[i]] === 'string') {
                stringVal = data[keys[i]].trim();
            }
            if (typeof data[keys[i]] === 'number') {
                numberVal = data[keys[i]];
            }
            if (stringVal === '' || numberVal === 0) {
                isBlank = true;
                break;
            }

        }
        return isBlank;
    }

    isSpecialCharAvailable(data) {
        if (data.indexOf('\'') > -1 || data.indexOf('"') > -1) {
            return true;
        } else {
            return false;
        }
    }

    ticketConverter(date, type) {
        if (date !== undefined && date !== '' && date !== null) {
            // console.log(date, typeof date);
            const d = new Date(date);
            const hour = d.getHours();
            const min = d.getMinutes();
            const year = d.getFullYear();
            const month = d.getMonth() + 1;
            const day = d.getDate();
            let nHour, nMin, nMonth, nDay;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            if (month < 10) {
                nMonth = '0' + month;
            } else {
                nMonth = month;
            }
            if (day < 10) {
                nDay = '0' + day;
            } else {
                nDay = day;
            }
            if (type === 1) {
                return year + '-' + nMonth + '-' + nDay;
            } else if (type === 3) {
                return nDay + '-' + nMonth + '-' + year;
            } else {
                return nDay + '-' + nMonth + '-' + year + ' ' + nHour + ':' + nMin;
            }
        } else {
            return '';
        }
    }

    setModalData(data: any) {
        this.modalSubject.next(data);
    }

    getModalData(): Observable<any> {
        // this.modalSubject = new Subject<any>();
        return this.modalSubject.asObservable();
    }

    clearSession() {
        sessionStorage.removeItem('id');
        sessionStorage.removeItem('data');
        sessionStorage.removeItem('grp');
        sessionStorage.removeItem('cat1');
        sessionStorage.removeItem('cat2');
        sessionStorage.removeItem('dd');
        sessionStorage.removeItem('src');
        sessionStorage.removeItem('spFltr');
        sessionStorage.removeItem('clientId');
    }

    addSessionData(id, token, clientId) {
        sessionStorage.setItem('id', id);
        sessionStorage.setItem('data', token);
        sessionStorage.setItem('clientId', clientId);
    }

    setClientId(clientId) {
        sessionStorage.setItem('clientId', clientId);
    }

    getclientId() {
        return sessionStorage.getItem('clientId');
    }


    minToDHM(minute) {
        let min = Number(minute);
        let hour = 0, day = 0;
        let h = 'hr';
        const m = 'mins';
        if (min > 59) {
            hour = Math.floor(min / 60);
            min = min % 60;
            // console.log('1: ' + hour, min);
        }
        if (hour > 23) {

            day = Math.floor(hour / 24);
            hour = hour % 24;
            // console.log('2: ' + hour, day);
        }
        if (day > 0) {
            let d = 'day';
            if (day > 1) {
                d = 'days';
            }
            if (hour > 1) {
                h = 'hrs';
            }
            if (hour === 0) {
                return day + d + ' ' + min + m;
            }
            if (min === 0) {
                return day + d + ' ' + hour + h;
            } else {
                return day + d + ' ' + hour + h + ' ' + min + m;
            }
        } else {
            if (hour > 1) {
                h = 'hrs';
            }
            if (min === 0) {
                return hour + h;
            } else {
                return hour + h + ' ' + min + m;
            }
        }
    }

    isEmptyJSON(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    logOut() {
        this.clearSession();
        window.location.href = this.logOutUrl;
        // this._rest.getIpClient().subscribe((res1) => {
        //     this.respObject = res1;
        //     const ip = this.respObject.ip;
        //     const data1 = {
        //         clientId: this.clientId, user_id: this.getUserId(), ip_address: ip, action_id: 2
        //     };
        //     this._rest.insertUserSession(data1).subscribe((re2) => {
        //
        //     });
        //     window.location.href = this.API_ROOT;
        // });
    }

    saveSupportGroup(data) {
        sessionStorage.setItem('grp', JSON.stringify(data));
    }

    setSpecialFilter(data) {
        sessionStorage.setItem('spFltr', JSON.stringify(data));
    }

    saveMenuData(data) {
        sessionStorage.setItem('dd', JSON.stringify(data));
    }

    getSpecialFilter() {
        return JSON.parse(sessionStorage.getItem('spFltr'));
    }

    getSupportGroup() {
        return JSON.parse(sessionStorage.getItem('grp'));
    }

    saveCategory1(data) {
        sessionStorage.setItem('cat1', JSON.stringify(data));
    }

    saveCategory2(data) {
        sessionStorage.setItem('cat2', JSON.stringify(data));
    }

    getCategory1() {
        return JSON.parse(sessionStorage.getItem('cat1'));
    }

    getCategory2() {
        return JSON.parse(sessionStorage.getItem('cat2'));
    }

    saveSourceType(data) {
        sessionStorage.setItem('src', data);
    }

    getSourceType() {
        return sessionStorage.getItem('src');
    }

    datePipeFunc(value) {
        const date = new Date(value);
        // const hourOffset = Math.ceil(date.getTimezoneOffset() / 60);
        // const minOffSet = date.getTimezoneOffset() % 60;
        // const hours = date.getHours();
        // const minutes = date.getMinutes();
        // date.setHours(hours - hourOffset);
        // date.setMinutes(minutes - minOffSet);
        // console.log(date);
        // const options = {
        //     weekday: 'long', year: 'numeric', month: 'short',
        //     day: 'numeric', hour: '2-digit', minute: '2-digit'
        // };
        // return date.toLocaleTimeString('en-us', options);
        return this.ticketConverter(date, 2);
    }

    dateFunction(value) {
        if (value !== undefined && value !== '' && value !== null) {
            const date = new Date(value);
            return this.ticketConverter(date, 3);
        } else {
            return '';
        }
    }

    getQueryStringValue(name, url) {
        // return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' +
        //     encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
        // const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    setWorkspace(data) {
        sessionStorage.setItem('wp', JSON.stringify(data));
    }

    getWorkspace() {
        return JSON.parse(sessionStorage.getItem('wp'));
    }

    exportAsExcelFile(json: any[]): void {
        const fileName = 'export.xlsx';
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        XLSX.writeFile(wb, fileName);
    }
}
